import React from 'react'

const About = () => {
  return (
    <section className='section  about-section'>
      <h1 className='section-title'>about us</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Vitae quisquam
        deserunt rem mollitia voluptate qui amet optio molestias, id possimus
        nesciunt cumque repellendus atque accusantium in nemo voluptatibus?
        Nostrum architecto illum necessitatibus itaque perferendis adipisci
        sapiente repellat quis rem possimus.
      </p>
    </section>
  )
}

export default About
